// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"qP-z","categoryName":"rP-z","categoryNameSearchHeader":"sP-z","categoryContent":"tP-z","bottomAligned":"uP-z","image":"vP-z","imageNoBackground":"wP-z"};